import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "copy",
  "use": "copy-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"copy\">\n<path d=\"M9.33341 0.583252H2.33341C1.69175 0.583252 1.16675 1.10825 1.16675 1.74992V9.91659H2.33341V1.74992H9.33341V0.583252ZM8.75008 2.91659L12.2501 6.41659V12.2499C12.2501 12.8916 11.7251 13.4166 11.0834 13.4166H4.66091C4.01925 13.4166 3.50008 12.8916 3.50008 12.2499L3.50591 4.08325C3.50591 3.44159 4.02508 2.91659 4.66675 2.91659H8.75008ZM8.16675 6.99992H11.3751L8.16675 3.79159V6.99992Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol